import { toast } from '@hivebrite/design-system/Toast';

import { incrementDownload } from 'hb-react/shared/components/FilePreview/utils/fileAnalytics';
import copyToClipboard from 'hb-react/shared/utils/copyToClipboard';
import { isFileExternalSource } from 'hb-react/shared/utils/files/fileContentTypes';

const getCopyLinkAction = (url, icon) => ({
  label: s__('Portfolio|Copy link'),
  icon,
  onClick: () =>
    copyToClipboard(url, () => toast.success(__('Link copied to clipboard'))),
});

export const getActionItems = (file, fileUrl, icons) => {
  const copyLinkActionOther = getCopyLinkAction(fileUrl, icons.copyLink);

  const downloadAction = {
    label: s__('MediaCenter|Download'),
    icon: icons.download,
    onClick: () => {
      if (file.uuid) {
        incrementDownload(file.uuid);
      }
      window.open(file.download_url, '_blank');
    },
  };

  const openAction = {
    label: s__('MediaCenter|Open'),
    icon: icons.arrowUpRight,
    onClick: () => window.open(file.url, '_blank'),
  };

  if (isFileExternalSource(file.file_type)) {
    const copyLinkActionExternal = getCopyLinkAction(file.url, icons.copyLink);

    return [copyLinkActionExternal, openAction];
  }

  if (!file.is_downloadable) {
    return [copyLinkActionOther];
  }

  return [copyLinkActionOther, downloadAction];
};
